export const addDonationModalStyle = {
	wrapper: {
		width: '100%',
		position: 'relative',
	},

	title: {
		textAlign: 'center',
		marginBottom: '40px',

		'@media (max-width: 639.98px)': {
			display: 'none',
		},
	},

	search: {
		position: 'relative',
		width: '100%',

		svg: {
			position: 'absolute',
			left: '10px',
			top: '30px',
		},

		'& .MuiFormControl-root .MuiInputBase-root input': {
			paddingLeft: '40px',
			width: '100%',

			'&::placeholder': {
				color: 'var(--neutral-300)',
			},
		},
		'& .MuiFormControl-root .MuiInputBase-root fieldset': {
			background: 'transparent',
		},
	},

	itemList: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		textAlign: 'start',

		'@media (max-width: 639.98px)': {
			padding: '0 20px',
		},
	},

	popup: {
		padding: '20px',
	},

	drawer: {
		'& .MuiPaper-root': {
			padding: 0,
		},

		'@media (min-width: 640px)': {
			display: 'none',
		},
	},

	container: {
		backgroundColor: 'var(--primary-500)',
		height: '100px',
		display: ' flex',
		alignItems: 'center',
		padding: '44px 20px 16px',
		gap: '16px',
		position: 'relative',
		marginBottom: '16px',

		'@media (min-width: 640px)': {
			display: 'none',
		},

		svg: {
			width: '24px',
			height: '24px',
			path: {
				fill: 'var(--default-white)',
			},

			'@media (max-width: 639.98px)': {
				width: '20px',
				height: '20px',
			},
		},
	},

	headerTitle: {
		fontWeight: 700,
		color: 'var(--default-white)',
		fontSize: '20px',
		display: 'flex',
		alignItems: 'center',

		'@media (min-width: 640px)': {
			fontSize: '24px',
			position: 'absolute',
			left: '50%',
			top: '50%',
			transform: 'translate(-50%, -50%)',
			width: 'max-content',
			textAlign: 'center',
		},
	},
};
